import { AiApiWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('AI')
export class AINodeSchemaProvider extends SchemaProvider<AiApiWorkflowNode> {}
